// IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12)
// Режим вида ячеек «Plans: fulfilment» (plans; uk «Плани: виконання»). Спутник ячейки-даты plan_val = { мера: { plan: P, fact: F } } (нет fact —
// факт = значение ячейки). Круг — доля F / P: тёмный слой ('solid') — факт (не больше плана), светлый ('light-2') — остаток плана P − F;
// F > P — сигнал over-100 (красное кольцо), круг целиком тёмный. Размер — по P: layersOf → sizeValue = P (cellRing_build opts.sizeValue, диаметр по
// max(P, F) в шкале группы), value = F. Нет 'plan' (или P ≤ 0) — только факт обычным кругом (по значению в шкале).
// Подсказка «План P · Факт F · x%» (tipOf → { caption, note }). Тесты — tests/unit/cellViewPlans.test.mjs
import { t as tI18n } from '@/i18n'
import { CELL_RING_COLORS } from '@/utils/cellRing'

export const PLANS_VIEW = 'plans'
export const PLANS_COLOR = '#00897b'   // тёмный слой (факт); остаток плана — тот же цвет тоном light-2
export const PLANS_REST_TONE = 'light-2'

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const isObj = (o) => !!o && typeof o === 'object' && !Array.isArray(o)
const isNum = (v) => v !== undefined && v !== null && v !== '' && Number.isFinite(Number(v))

// план / факт ячейки: planVal — спутник plan_val, measure — мера ячейки, cellValue — значение ячейки (факт, если в спутнике нет fact)
// → { plan (число | null — плана нет), fact, share (F / P | null), over } | null (нет спутника меры и нет значения)
export function plans_of(planVal, measure, cellValue) {
    const ms = str(measure)
    if (!ms) return null
    const pm = isObj(planVal) && isObj(planVal[ms]) ? planVal[ms] : null
    if (!pm) return null
    const fact = isNum(pm.fact) ? Number(pm.fact) : (isNum(cellValue) ? Number(cellValue) : 0)
    const plan = isNum(pm.plan) && Number(pm.plan) > 0 ? Number(pm.plan) : null
    const share = plan ? fact / plan : null
    return { plan, fact, share, over: plan !== null && fact > plan }
}

// слои круга и сигналы: { layers, signals, value, sizeValue? } | null (нечего рисовать)
export function plans_layers(pf, t = tI18n) {
    if (!pf) return null
    const tt = typeof t === 'function' ? t : (x) => x
    const f = Math.max(0, pf.fact)
    if (pf.plan === null) {
        if (!(f > 0)) return null
        return { layers: [{ key: 'fact', title: tt('Fact'), value: f, color: PLANS_COLOR, tone: 'solid' }], signals: [], value: pf.fact }
    }
    const p = pf.plan
    const layers = []
    if (f > 0) layers.push({ key: 'fact', title: tt('Fact'), value: Math.min(f, p), color: PLANS_COLOR, tone: 'solid' })
    if (p > f) layers.push({ key: 'rest', title: tt('Plan remaining'), value: p - f, color: PLANS_COLOR, tone: PLANS_REST_TONE })
    const signals = pf.over ? [{ kind: 'over-100', color: CELL_RING_COLORS['over-100'] }] : []
    return { layers, signals, value: pf.fact, sizeValue: p }
}

const pctText = (s) => (s === null || !Number.isFinite(s) ? '' : `${Math.round(s * 1000) / 10}%`)

export default {
    key: PLANS_VIEW,
    title: 'Plans: fulfilment',
    satellites: ['plan_val'],
    needsData: true,
    // ctx: { t, date, measure, cell (= dataItem[date]), value }
    layersOf(dataItem, binding, ctx = {}) {
        const cell = ctx.cell
        if (!isObj(cell)) return null
        const pf = plans_of(cell.plan_val, ctx.measure, ctx.value)
        const res = plans_layers(pf, ctx.t || tI18n)
        if (!res) return null
        return { ...res, pf, satellite: 'plan_val' }
    },
    tipOf(res, ctx = {}) {
        const t = ctx.t || tI18n
        const fmt = typeof ctx.fmt === 'function' ? ctx.fmt : (v) => String(v)
        const pf = res && res.pf
        const caption = t('Plan fulfilment')
        if (!pf) return { caption }
        if (pf.plan === null) return { caption, note: [t('No plan'), `${t('Fact')} ${fmt(pf.fact)}`] }
        return { caption, note: [t('Plan {plan} · Fact {fact} · {pct}', { plan: fmt(pf.plan), fact: fmt(pf.fact), pct: pctText(pf.share) })] }
    },
    cacheKey(dataItem, ctx = {}) {
        const c = ctx.cell
        const pm = isObj(c) && isObj(c.plan_val) ? c.plan_val[str(ctx.measure)] : undefined
        return isObj(pm) ? `${isNum(pm.plan) ? pm.plan : '-'}|${isNum(pm.fact) ? pm.fact : '-'}` : '-'
    },
}
